var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareArrowNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4933 50.4166H14.8981C5.99957 50.4166 0 44.6918 0 36.1487V14.2931C0 5.74749 5.99957 0 14.8981 0H35.4933C44.417 0 50.4166 5.74749 50.4166 14.2931V36.1487C50.4166 44.6918 44.417 50.4166 35.4933 50.4166ZM30.93 23.3177H14.9228C13.864 23.3177 13.0321 24.1747 13.0321 25.2083C13.0321 26.267 13.864 27.0989 14.9228 27.0989H30.93L24.6784 33.3254C24.3254 33.6783 24.1238 34.1824 24.1238 34.6614C24.1238 35.1378 24.3254 35.6193 24.6784 35.9974C25.4094 36.7285 26.6194 36.7285 27.3504 35.9974L36.854 26.5443C37.5598 25.8385 37.5598 24.5781 36.854 23.8722L27.3504 14.4191C26.6194 13.6881 25.4094 13.6881 24.6784 14.4191C23.9473 15.1754 23.9473 16.3602 24.6784 17.1164L30.93 23.3177Z",
    fill: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrowNext);
export default __webpack_public_path__ + "static/media/square-arrow-next.04539c36f84bb55bea1e1d4f3ea3ff10.svg";
export { ForwardRef as ReactComponent };